import { ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { render } from "react-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Col, Row, Space, Spin, Tooltip, Button, message, Alert } from "antd";
import "react-data-grid/lib/styles.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./logs-table.scss";
import Meta from "../../../../Meta";
import { CSVLink } from "react-csv";
import {
  AUTO_PROVISIONING_CLIENT,
  MetaTitle,
} from "../../../../common/constants/constants";
import { service } from "../../../../services";
const LogsTable = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const gridRef = useRef();
  const dataFetchedRef = useRef(false);
  const [snapshotDataList, setSnapshotDataList] = useState([]);
  const [filterdata, setFilterData] = useState(["1", "2"]);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [rowData, setRowData] = useState([]);
  const [last, setLast] = useState();
  const [columnDefs, setcolumnDefs] = useState([]);
  var params = useParams();
  const [Nodata, setNoData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const perPage = 1000;
  const onGridReady = (params) => {
    setGridApi(params?.api);
  };
  const popupParent = useMemo(() => {
    return document?.body;
  }, []);
  useEffect(() => {
    if (location?.state?.data?.length > 0) {
      if (gridApi) {
        const data = location?.state?.data;
        const dataSource = {
          getRows: (params) => {
            setLoader(true);
            const page = params?.endRow / perPage;
            let payload = {
              page: page,
              size: perPage,
              startDate: data[0]?.startDate,
              endDate: data[0]?.endDate,
              databaseId: data[0]?.databaseId,
            };
            service?.falconViewLogs(payload).then((res) => {
              if (res?.success === false) {
                params?.successCallback(["0"], 0);
                setRowData(["1"]);
                setNoData([]);
                setLoader(false);
              } else {
                params?.successCallback(
                  res?.data?.data,
                  parseInt(res?.data?.totalCount)
                );
                const colDefs = [];
                colDefs.length = 0;
                if (res?.data?.data?.length > 0) {
                  const keys = Object?.keys(res?.data?.data[0]);
                  delete keys[0];
                  keys?.forEach((key) => colDefs?.push({ field: key }));
                  setcolumnDefs(colDefs);
                }
                setRowData(res?.data?.data);
                setNoData(res?.data?.data);
                setLoader(false);
              }
            });
          },
        };
        gridApi?.setDatasource(dataSource);
      }
    } else {
      setRowData(["1"]);
      setNoData([]);
      setLoader(false);
    }
  }, [gridApi]);
  const defaultColDef = useMemo(() => {
    return {
      width: 220,
      editable: false,
      filter: "agTextColumnFilter",
      floatingFilter: true,
      resizable: true,
    };
  }, []);
  const defaultColGroupDef = useMemo(() => {
    return {
      marryChildren: true,
    };
  }, []);
  const columnTypes = useMemo(() => {
    return {
      numberColumn: { width: "100%", filter: "agNumberColumnFilter" },
      medalColumn: { width: "100%", columnGroupShow: "open", filter: false },
      nonEditableColumn: { editable: false },
      dateColumn: {
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => {
            const dateParts = cellValue.split("/");
            const day = Number(dateParts[0]);
            const month = Number(dateParts[1]) - 1;
            const year = Number(dateParts[2]);
            const cellDate = new Date(year, month, day);
            // Now that both parameters are Date objects, we can compare
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          },
        },
      },
    };
  }, []);
  useEffect(() => {}, []);

  return (
    <>
      <Meta name={MetaTitle.FalconLogsDetails} />
      {loader && <Spin />}
      <div className="logs-H">
        <h1 className="page-container-title-logsdetails">
          {" "}
          <ArrowLeftOutlined
          
            onClick={() =>
              navigate("/falcon/logs", { state: location?.state?.data })
            }
            className="logs-Arrow outline"
          />
          {location?.state?.data[0]?.databasename} Logs
        </h1>
      </div>
      <Row>
        <div
          className="ag-theme-alpine1 box"
          style={{
            width: "98.4%",
          }}
        >
          <div style={containerStyle}>
            <div
              className="paginaton-grid-tab ag-theme-alpine1 box"
              style={{ boxSizing: "border-box" }}
            >
              <div
                style={gridStyle}
                className="ag-theme-alpine ag-theme-alpine1 box"
              >
                <AgGridReact
                  pagination={true}
                  rowModelType={"infinite"}
                  paginationPageSize={perPage}
                  cacheBlockSize={perPage}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  defaultColGroupDef={defaultColGroupDef}
                  columnTypes={columnTypes}
                ></AgGridReact>
              </div>
              {Nodata?.length === 0 && loader === false ? (
                <div style={{ left: "5%", top: "10%" }} className="ag-overlay">
                  <div className="ag-overlay-panel">
                    <div className="ag-overlay-wrapper">
                      <span className="ag-overlay-center">
                        No Data Found...
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </Row>
    </>
  );
};

export default LogsTable;
